import { render, staticRenderFns } from "./ProductsMainPage.vue?vue&type=template&id=224cfda0&scoped=true&"
import script from "./ProductsMainPage.vue?vue&type=script&lang=js&"
export * from "./ProductsMainPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsMainPage.vue?vue&type=style&index=0&id=224cfda0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224cfda0",
  null
  
)

export default component.exports